import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=6c7443f8&scoped=true&"
import script from "./ProjectItem.vue?vue&type=script&lang=ts&"
export * from "./ProjectItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectItem.vue?vue&type=style&index=0&id=6c7443f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7443f8",
  null
  
)

export default component.exports